import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-panel tech-grid-light py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-217" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-218" data-mp="j8hw2hd92zet">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-219" data-mp="j5c8x7o6m7lq">
          Todo lo que incluye
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-220" data-mp="1bwvwt4vq49u2">
          {productShortName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-ink" data-id="element-221" data-mp="16v6j1hh49i2a">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-222" data-mp="12vpaugab26tf">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-cream p-4" data-id="element-223" data-mp="3rn8kwm2fq4ew">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent" data-id="element-224" data-mp="3nl57vt04arri">
                <CheckIcon className="h-3.5 w-3.5 text-navyDeep" aria-hidden="true" data-id="element-225" data-mp="3ie7kay8n3gef" />
              </span>
              <p data-id="element-226" data-mp="3naoadxzeg4u5">
                <b className="block text-sm text-ink" data-id="element-227" data-mp="3nb7ot4pucb3f">{feature}</b>
                <span className="text-sm text-muted" data-id="element-228" data-mp="39b6fr1zf9xcv">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-gold bg-cream px-6 py-5 text-center text-lg font-bold leading-relaxed text-ink" data-id="element-229" data-mp="3dc02hs14p646">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}